import { logger } from "../../../lib/logger";

interface ActionButtonsProps {
  onCalculate: (skipSave?: boolean) => void;
  onReset: () => void;
  showResults: boolean;
  isAdmin: boolean;
  isCalculating?: boolean;
}

export function ActionButtons({ onCalculate, onReset, showResults, isAdmin, isCalculating = false }: ActionButtonsProps) {
  const handleCalculate = () => {
    logger.featureUsed('calculate_button_clicked');
    onCalculate();
  };

  const handleCalculateWithoutSave = () => {
    logger.featureUsed('calculate_without_save_clicked');
    onCalculate(true);
  };

  const handleReset = () => {
    logger.featureUsed('reset_button_clicked');
    onReset();
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full max-w-2xl">
      <button
        onClick={handleCalculate}
        disabled={isCalculating}
        className="flex-1 px-6 py-3 rounded-md font-subheader transition-colors bg-cyan text-white hover:bg-cyan-dark dark:bg-cyan-light dark:hover:bg-cyan shadow-sm hover:shadow disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isCalculating ? (
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            Calculating...
          </div>
        ) : (
          showResults ? "Recalculate" : "Calculate"
        )}
      </button>
      
      {isAdmin && (
        <button
          onClick={handleCalculateWithoutSave}
          disabled={isCalculating}
          className="flex-1 px-6 py-3 rounded-md font-subheader transition-colors border bg-white text-cyan border-cyan hover:bg-cyan-50 dark:bg-navy-light dark:text-cyan-light dark:border-cyan-light dark:hover:bg-navy shadow-sm hover:shadow disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Calculate (No Save)
        </button>
      )}
      
      <button
        onClick={handleReset}
        disabled={isCalculating}
        className="px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-md font-subheader hover:bg-gray-50 dark:bg-navy-light dark:text-gray-300 dark:border-gray-600 dark:hover:bg-navy transition-colors shadow-sm hover:shadow disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Reset
      </button>
    </div>
  );
}
